interface VerbatimCandidate {
  is_version_2?: boolean
  is_latest_version?: boolean
  submitted_attachment?: unknown
  submitted_attachment_source?: string | null
}

// The lead payload names the file only by submitted_attachment_source, null when the caller can see none.
export const signsAsVerbatimRecord = (record: VerbatimCandidate): boolean =>
  record.is_version_2 !== true &&
  record.is_latest_version !== false &&
  (!!record.submitted_attachment || !!record.submitted_attachment_source)
